"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSingleFinancingQuery = exports.financingQueries = exports.queryLoanPrivate = exports.queryLeasingPrivate = exports.queryLoanBusiness = exports.queryLeasingBusiness = exports.queryAllPrivate = exports.queryAllBusiness = exports.privateLoan = exports.privateLeasing = exports.businessLoan = exports.businessLeasing = void 0;
const types_1 = require("../../types");
const enums_1 = require("../../../enums");
exports.businessLeasing = `
  calculateBusinessLeasing(input: $leasingInput) {
    ${types_1.businessLeasingFields}
  }
`;
exports.businessLoan = `
  calculateBusinessLoan(input: $loanInput) {
    ${types_1.businessLoanFields}
  }
`;
exports.privateLeasing = `
  calculatePrivateLeasing(input: $leasingInput) {
    ${types_1.privateLeasingFields}
  }
`;
exports.privateLoan = `
  calculatePrivateLoan(input: $loanInput) {
    ${types_1.privateLoanFields}
  }
`;
exports.queryAllBusiness = `
  query calculateBusiness($leasingInput: BusinessLeasingInput!, $loanInput: BusinessLoanInput!) {
    ${exports.businessLeasing}
    ${exports.businessLoan}
  }
`;
exports.queryAllPrivate = `
  query calculatePrivate($leasingInput: PrivateLeasingInput!, $loanInput: PrivateLoanInput!) {
    ${exports.privateLeasing}
    ${exports.privateLoan}
  }
`;
exports.queryLeasingBusiness = `
  query calculateLeasingBusiness($leasingInput: BusinessLeasingInput!) {
    ${exports.businessLeasing}
  }
`;
exports.queryLoanBusiness = `
  query calculateLoanBusiness($loanInput: BusinessLoanInput!) {
    ${exports.businessLoan}
  }
`;
exports.queryLeasingPrivate = `
  query calculateLeasingPrivate($leasingInput: PrivateLeasingInput!) {
    ${exports.privateLeasing}
  }
`;
exports.queryLoanPrivate = `
  query calculateLoanPrivate($loanInput: PrivateLoanInput!) {
    ${exports.privateLoan}
  }
`;
exports.financingQueries = {
    leasing: {
        business: exports.queryLeasingBusiness,
        private: exports.queryLeasingPrivate,
    },
    loan: {
        business: exports.queryLoanBusiness,
        private: exports.queryLoanPrivate,
    },
};
const getSingleFinancingQuery = (financingType, customerType) => {
    const financing = financingType === enums_1.FinancingType.LEASING ? exports.financingQueries.leasing : exports.financingQueries.loan;
    return customerType === enums_1.CustomerType.BUSINESS ? financing.business : financing.private;
};
exports.getSingleFinancingQuery = getSingleFinancingQuery;
//# sourceMappingURL=financing.js.map